import React from "react";
import { IoIosClose } from "react-icons/io";

import { Autocomplete, TextField } from "@mui/material";

const CountryLanguageModal = ({
  show,
  editingItem,
  form,
  countries,
  languages,
  saving,
  combinedCodeLoading,
  error,
  onClose,
  onSubmit,
  onCountryChange,
  onLanguageChange,
  onCodeChange,
  getLanguageName,
  getLanguageCode,
}) => {
  if (!show) return null;

  const selectedCountry =
    countries.find((country) => country.name === form.country) || null;

  const selectedLanguage =
    languages.find((language) => getLanguageName(language) === form.language) ||
    null;

  const handleCountrySelect = (_event, newValue) => {
    onCountryChange({
      target: { value: newValue ? newValue.name : "" },
    });
  };

  const handleLanguageSelect = (_event, newValue) => {
    onLanguageChange({
      target: { value: newValue ? getLanguageName(newValue) : "" },
    });
  };

  return (
    <div className="fixed inset-0 z-[1050] flex items-center justify-center bg-black/50 px-3">
      <div className="w-full max-w-md rounded-[6px] bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
          <h5 className="m-0 text-base font-semibold text-gray-900">
            {editingItem ? "Edit Country Language" : "Add Country Language"}
          </h5>
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          aria-label="Close"
          className="flex h-7 w-7 items-center rounded-full p-0 justify-center border-2 border-black hover:bg-gray-100"
        >
          <IoIosClose size={30} />
        </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="space-y-3 px-4 py-3">
            {error && (
              <div className="rounded-[4px] border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                {error}
              </div>
            )}

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Country
              </label>
              <Autocomplete
                size="small"
                options={countries}
                value={selectedCountry}
                getOptionLabel={(option) => option?.name || ""}
                isOptionEqualToValue={(option, value) =>
                  option.code_3 === value?.code_3
                }
                onChange={handleCountrySelect}
                disabled={saving}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select country"
                    variant="outlined"
                  />
                )}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  },
                }}
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Language
              </label>
              <Autocomplete
                size="small"
                options={languages}
                value={selectedLanguage}
                getOptionLabel={(option) => getLanguageName(option) || ""}
                isOptionEqualToValue={(option, value) =>
                  getLanguageCode(option) === getLanguageCode(value)
                }
                onChange={handleLanguageSelect}
                disabled={saving}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select language"
                    variant="outlined"
                  />
                )}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  },
                }}
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">
                Code
              </label>
              <input
                type="text"
                className="form-control h-auto rounded-[4px] px-3 py-2 text-sm uppercase"
                value={form.combined_code}
                onChange={onCodeChange}
                placeholder="DNK-DK"
                disabled={saving || combinedCodeLoading}
              />
              {combinedCodeLoading && (
                <div className="mt-1 text-xs text-gray-500">Loading code...</div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 border-t border-gray-200 px-4 py-3">
            <button
              type="button"
              className="btn btn-sm btn-secondary px-3"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-sm bg_color px-3"
              disabled={saving || combinedCodeLoading}
            >
              {saving ? "Saving..." : editingItem ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CountryLanguageModal;